module.exports = __webpack_public_path__ + "img/PRNT_05_mono_AE_00005.8b057ac0.png";